interface DropdownProps {
  children: React.ReactNode
}

export default function Dropdown({ children }: DropdownProps) {
  return <div>{children}</div>
} 